






import Vue from "vue";
import Component from "vue-class-component";
import Menu from "@/views/MainMenu.vue";
@Component({
  components: { Menu },
})
export default class App extends Vue {
  /**
   * Sets language for app based on host's SO language
   */
  created() {
    // (get the first locale in the list)
    this.$i18n.locale = navigator.languages[0];
  }
}
